import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TesteAssinaturaEletronicaComponent } from './teste-assinatura-eletronica.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TesteAssinaturaEletronicaComponent
  ],
  imports: [
    RouterModule,
    TranslateModule,
    CommonModule,
    LocalizeRouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    TesteAssinaturaEletronicaComponent
  ]
})

export class TesteAssinaturaEletronicaModule { }
